import React, { useState } from 'react'
import { get } from '../modules/fetch'

let component_mounted = false
const model = 'article'

const ArticleView = props => {
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false
    const [status, setStatus] = useState((id && 'fetching') || 'ready')
    const [object, setObject] = useState({})
    // const [html, setHTML] = useState({})

    // if (!component_mounted && id) {
    //     component_mounted = true
    //     get(model + '/' + id)
    //         .then(r => r.json())
    //         .then(r => console.log(r) || r)
    //         .then(r => {
    //             setObject(r)
    //             const html = ((r.body.substring(0, 1) === '{' || r.body.substring(0, 1) == '[') && JSON.parse(r.body)) || r.body
    //             setHTML(html)
    //             setStatus('ready')
    //         })
    // }

    return (
        <React.Fragment>
            {status !== 'fetching' && (
                <React.Fragment>
                    <h1 className='mb-3'>{object.title}</h1>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default ArticleView
